<div id="chart" class="w-full">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [stroke]="chartOptions.stroke"
    [dataLabels]="chartOptions.dataLabels"
    [yaxis]="chartOptions.yaxis"
    [legend]="chartOptions.legend"
    [title]="chartOptions.title"
    [fill]="chartOptions.fill"
    [grid]="chartOptions.grid"
  ></apx-chart>
</div>
